import React, { FC } from "react";
import {
  CardIconWrapper,
  CardIconWrapperProps,
} from "../CardIconWrapper/CardIconWrapper";

import { Icon } from "@UI/Components/Icon/Icon";

import { PayPalIcon } from "../../../Icons/PayPal/PayPal";

type Props = Omit<CardIconWrapperProps, "children">;

export const PayPalCardIcon: FC<Props> = (props) => {
  return (
    <CardIconWrapper {...props}>
      <Icon as={PayPalIcon} />
    </CardIconWrapper>
  );
};
